import App from '@/App.vue'
import vuetify from '@/plugins/vuetify'
import router from '@/router'
import store from '@/store'
import MeltingPointDesignSystem from '@meltingpoint/lastmile-design-system'
import '@meltingpoint/lastmile-design-system/lastmile-design-system.css'
import Vue from 'vue'
import Config from './config/Config'
import Repository from './services/Repository'

Vue.config.productionTip = false
Vue.use(MeltingPointDesignSystem)

Config.load().then(async () => {
  // Change default baseUrl for axios call
  Repository.defaults.baseURL = Config.get('VUE_APP_API_BASE_URL')

  const { loadI18n } = await import('@/plugins/i18n')
  const i18n = loadI18n(Config.get('TRANSLATION_URL'))

  new Vue({
    router,
    store,
    vuetify,
    i18n,
    render: h => h(App),
  }).$mount('#app')
})
